import { type ReactNode, useState } from "react";
import { MobileSidebar } from "./mobile-sidebar";
import { Sidebar } from "./sidebar";
import { SidebarProvider } from "./sidebar-context";
import { Topbar } from "./topbar";

interface AppLayoutProps {
  children: ReactNode;
  fullBleed?: boolean;
  ownerId?: string | null;
}

export function AppLayout({ children, fullBleed, ownerId }: AppLayoutProps) {
  return (
    <SidebarProvider>
      <AppLayoutInner fullBleed={fullBleed} ownerId={ownerId}>
        {children}
      </AppLayoutInner>
    </SidebarProvider>
  );
}

function AppLayoutInner({ children, fullBleed, ownerId }: AppLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar ownerId={ownerId} />
      <MobileSidebar open={mobileOpen} onOpenChange={setMobileOpen} ownerId={ownerId} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar onMobileMenuOpen={() => setMobileOpen(true)} />
        {fullBleed ? (
          <main className="flex-1 flex flex-col overflow-hidden">{children}</main>
        ) : (
          <main className="flex-1 overflow-auto lg:p-8 p-4">
            <div className="max-w-7xl mx-auto">{children}</div>
          </main>
        )}
      </div>
    </div>
  );
}
